export function filterMap<T, U>(arr: T[], f: (item: T, index) => U | undefined | null): U[] {
  return arr.reduce((acc, item, index) => {
    const mapped = f(item, index);
    if (mapped != null) {
      acc.push(mapped);
    }
    return acc;
  }, [] as U[]);
}

export function mapValues<T, In extends T[keyof T], Out>(object: T, f: (value: In) => Out): Record<keyof T, Out> {
  return Object.fromEntries(Object.entries(object).map(([k, v]) => [k, f(v as In)])) as Record<keyof T, Out>;
}

export function filterValues<K extends string|number|symbol, V>(object: Record<K, V>, f: (value: V) => boolean): Record<K, V> {
  return Object.fromEntries(Object.entries(object).filter(([k, v]) => f(v as V))) as Record<K, V>;
}
